import cn from 'classnames';
import { ReactNode } from 'react';
import { Link } from 'src/components/Link';
import { Logo } from 'src/components/Logo';

import s from './Footer.module.scss';

function LogoDefault() {
  return (
    <Link
      href="/"
      id={`promo-products-footer`}
      analyticsOptions={{
        action: 'click',
        clickZone: 'footer',
        clickElement: 'textclick',
        clickContent: 'logo',
        uniqueId: `promo-products-footer`,
        transitionType: 'inside-link',
      }}
    >
      <Logo className={s.logo} />
    </Link>
  );
}

export function Footer({
  className = '',
  children,
}: {
  className?: string;
  children?: ReactNode;
}) {
  const year = new Date().getFullYear();

  return (
    <section className={cn(s.root, className)}>
      <div className={s.wrapper}>
        <div className={s.innerWrapper}>
          {children ?? <LogoDefault />}
          <span className={s.copyright}>©&nbsp;{year}&nbsp;Cloud.ru</span>
        </div>
      </div>
    </section>
  );
}
